export enum ROLE {
  ADMIN = "ADMIN",
  USER = "USER"
}

export enum PERMISSION {
  VIEW_DOCUMENTS = "VIEW_DOCUMENTS",
  ADD_DOCUMENTS = "ADD_DOCUMENTS",
  EDIT_DOCUMENTS = "EDIT_DOCUMENTS",
  DELETE_DOCUMENTS = "DELETE_DOCUMENTS",
  VIEW_SETTING = "VIEW_SETTING",
  EDIT_SETTING = "EDIT_SETTING"
}
export const PERMISSIONS = {
  [ROLE.ADMIN]: [
    PERMISSION.VIEW_DOCUMENTS,
    PERMISSION.ADD_DOCUMENTS,
    PERMISSION.EDIT_DOCUMENTS,
    PERMISSION.DELETE_DOCUMENTS,
    PERMISSION.VIEW_SETTING,
    PERMISSION.EDIT_SETTING
  ],
  [ROLE.USER]: [
    PERMISSION.VIEW_DOCUMENTS,
    PERMISSION.ADD_DOCUMENTS,
    PERMISSION.EDIT_DOCUMENTS,
    PERMISSION.VIEW_SETTING
  ],
  NO_ROLE: [PERMISSION.VIEW_DOCUMENTS, PERMISSION.VIEW_SETTING]
};
